import { Route, Routes } from 'react-router-dom';

import { HeaderGeneral } from '@/components/DybrComponents/HeaderGeneral';
import { ServiceBackground } from '@/components/DybrComponents/ServiceBackground';
import { CommonFeed } from '@/scenes/Dybr/Feeds/CommonFeed';

function SearchScene() {
  return (
    <ServiceBackground data-testid="search-scene">
      <HeaderGeneral paddingBottom="45px">
        <h1>результаты поиска</h1>
      </HeaderGeneral>

      <Routes>
        <Route path="/" element={<CommonFeed isFiltered />} />
      </Routes>
    </ServiceBackground>
  );
}

export default SearchScene;
